import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const initialState = {
    loading: false,
    error: false
}

export const getAccessToken = createAsyncThunk('data/getAccessToken', async (params, { rejectWithValue }) => {
    try {
        const response = await axios.post(
            process.env.REACT_APP_ACCESSTOKEN_DETAIL,
            {
                query: `query{
                GetAccessToken
                {
                      accessToken
                }
                }`,
            }
        );
        const tokenResult = response.data.data.GetAccessToken.accessToken;
        localStorage.setItem("localaccesstoken", tokenResult);

        return tokenResult;
    }
    catch (error) {
        return rejectWithValue(error.message || 'Unexpected error');
    }
});

const tokenSlice = createSlice({
    name: 'token',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccessToken.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getAccessToken.fulfilled, (state, action) => {

                state.error = false;
                state.loading = false;

            })
            .addCase(getAccessToken.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            });
    },
})

export default tokenSlice.reducer;